export default function({ state, commit, dispatch }, { id, provider }) {
    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : provider) + '/patient/' + id + '/verify'
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => {
        throw error
    })
}
